import React from "react";

/**
 * Placeholder for dashboard modules until dedicated screens are implemented.
 *
 * @param {Object} props
 * @param {string} props.title - Page title shown in the content area
 * @param {string} [props.description] - Optional supporting text
 */
const PlaceholderModulePage = ({ title, description }) => {
  return (
    <div style={{ padding: "24px 32px", maxWidth: 720 }}>
      <h1
        style={{
          fontSize: 22,
          fontWeight: 600,
          margin: "0 0 8px 0",
          color: "rgba(0, 0, 0, 0.87)",
        }}
      >
        {title}
      </h1>
      <p style={{ margin: 0, color: "rgba(0, 0, 0, 0.6)", fontSize: 14 }}>
        {description ?? "This section is coming soon."}
      </p>
    </div>
  );
};

export default PlaceholderModulePage;
